import { Fragment } from 'react'
const CARD_BASE = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards'
const WINNER_ICON = 'https://wver.sprintstaticdata.com/v230/static/front/img/winner.png'

// teen62 detail-result — card string alternate deal (A = 0,2,4 / B = 1,3,5),
// rdesc = "Winner#Suits#Odd/Even#Consecutive" (hash-separated; suits row
// reference me hidden hai)
export default function Teen62Result({ detail }) {
  const codes = String(detail?.card || '').split(',').filter(Boolean)
  const handA = [codes[0], codes[2], codes[4]].filter(Boolean)
  const handB = [codes[1], codes[3], codes[5]].filter(Boolean)

  const parts = String(detail?.rdesc || '').split('#')
  const winner = detail?.winnat || parts[0] || ''
  const oddEven = parts[2] || ''
  const consecutive = parts[3] || ''
  const isAWinner = String(detail?.win) === '1'

  const cards = (hand, showWinner) => (
    <div className="casino-result-cards">
      {showWinner && (
        <div className="casino-result-cards-item">
          <img src={WINNER_ICON} className="winner-icon" />
        </div>
      )}
      {hand.map((c, i) => (
        <Fragment key={i}>
          {' '}
          <div className="casino-result-cards-item">
            <img src={`${CARD_BASE}/${c}.png`} />
          </div>
        </Fragment>
      ))}
    </div>
  )

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center">
            <h4>Player A</h4>
            {' '}
            {cards(handA, isAWinner)}
          </div>
          {' '}
          <div className="casino-result-content-diveder"></div>
          {' '}
          <div className="casino-result-content-item text-center">
            <h4>Player B</h4>
            {' '}
            {cards(handB, !isAWinner)}
          </div>
        </div>
      </div>
      {' '}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            {' '}
            <div>{winner}</div>
          </div>
          {' '}
          <div className="casino-result-desc-item">
            <div>Odd/Even</div>
            {' '}
            <div>{oddEven}</div>
          </div>
          {' '}
          <div className="casino-result-desc-item">
            <div>Consecutive</div>
            {' '}
            <div>{consecutive}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
